type DateOrStringOrNull = Date | string | null;

export enum TimeOffType {
  PAID = 'Paid',
  UNPAID = 'Unpaid',
}

export enum TimeOffStatus {
  APPROVED = 'Approved',
  DECLINED = 'Declined',
  PENDING = 'Pending',
  OVERDUE = 'Overdue',
}
export interface RequestTimeOff {
  policyId: number;

  roleId: number;

  timeOffStartDate: Date | null;

  timeOffEndDate: Date | null;

  employeeComment: string;
}

export interface EditTimeOff extends RequestTimeOff {
  status: TimeOffStatus;
}

export interface AllEmployeesTimeOffQuery {
  status?: TimeOffStatus[];

  type?: TimeOffType[];

  search?: string;

  pageNumber: number;

  myOwn: string;

  date: Date;
}

export interface UpdateTimeOffRequest {
  managerComment: string;
  status: TimeOffStatus;
}

export interface ActionedBy {
  firstName: string;
  lastName: string;
  id: number;
}
export interface TimeOff {
  id: number;
  type: TimeOffType;
  firstName: string;
  lastName: string;
  imgUrl: string | null;
  timeOffStartDate: Date;
  timeOffEndDate: Date;
  timeOffDays: number;
  employeeComment: string | null;
  actionedAt: Date | null;
  actionedBy: ActionedBy | null;
  managerComment: string | null;
  status: TimeOffStatus | null;
  createdBy: number;
  createdAt: Date;
}

export interface TimeOffPaginationMetaType {
  totalItems?: number;
  totalPages?: number;
  currentPage?: number;
  pageSize?: number;
}
export interface PaginatedTimeOffRequests {
  data: TimeOff[];
  meta: TimeOffPaginationMetaType;
}
export interface AllTimeOffFetchResponse {
  data: PaginatedTimeOffRequests | null;
}

export interface PartialDay {
  date: DateOrStringOrNull;
  startTime: DateOrStringOrNull;
  endTime: DateOrStringOrNull;
}
